import {
  create,
  NConfigProvider,
  NCarousel,
  NGlobalStyle,
  NSpace,
  NLayout,
  NLayoutHeader,
  NLayoutSider,
  NGrid,
  NGridItem,
  NMenu,
  NIcon,
  NButton,
  NInput,
  NImage,
  NRadio,
  NRadioGroup,
  NSlider,
  NSelect,
  NSwitch,
  NTooltip,
  NModal,
  NForm,
  NFormItem,
  NInputNumber,
  NColorPicker,
  NTag,
  NTabs,
  NTabPane,
  NCollapse,
  NCollapseItem,
  NUpload,
  NMessageProvider,
  NAutoComplete,
  NCard,
  NAvatar,
  NDropdown,
  NPagination
} from 'naive-ui'

const naive = create({
  components: [
    NConfigProvider,
    NMessageProvider,
    NGlobalStyle,
    NSpace,
    NLayout,
    NLayoutHeader,
    NLayoutSider,
    NCard,
    NGrid,
    NGridItem,
    NMenu,
    NCarousel,
    NButton,
    NIcon,
    NImage,
    NInput,
    NAutoComplete,
    NRadio,
    NRadioGroup,
    NSlider,
    NSelect,
    NSwitch,
    NTooltip,
    NModal,
    NForm,
    NFormItem,
    NInputNumber,
    NColorPicker,
    NTag,
    NTabs,
    NTabPane,
    NCollapse,
    NCollapseItem,
    NUpload,
    NAvatar,
    NDropdown,
    NPagination
  ]
})

export function setupNaive(app) {
  app.use(naive)
}
